{
  "$schema": "https://mux.run/theme.json",
  "name": "Palenight",
  "id": "palenight",
  "light": {
    "palette": {
      "neutral": "#fafafa",
      "ink": "#292d3e",
      "primary": "#4976eb",
      "accent": "#00acc1",
      "success": "#91b859",
      "warning": "#ffb300",
      "error": "#e53935",
      "info": "#f4511e"
    },
    "overrides": {
      "text-weak": "#8796b0",
      "syntax-comment": "#8796b0",
      "syntax-keyword": "#a854f2",
      "syntax-string": "#91b859",
      "syntax-primitive": "#4976eb",
      "syntax-variable": "#292d3e",
      "syntax-property": "#00acc1",
      "syntax-type": "#ffb300",
      "syntax-constant": "#f4511e",
      "syntax-operator": "#00acc1",
      "syntax-punctuation": "#292d3e",
      "syntax-object": "#292d3e",
      "markdown-heading": "#a854f2",
      "markdown-text": "#292d3e",
      "markdown-link": "#4976eb",
      "markdown-link-text": "#00acc1",
      "markdown-code": "#91b859",
      "markdown-block-quote": "#8796b0",
      "markdown-emph": "#ffb300",
      "markdown-strong": "#f4511e",
      "markdown-horizontal-rule": "#8796b0",
      "markdown-list-item": "#4976eb",
      "markdown-list-enumeration": "#00acc1",
      "markdown-image": "#4976eb",
      "markdown-image-text": "#00acc1",
      "markdown-code-block": "#292d3e"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#292d3e",
      "ink": "#a6accd",
      "primary": "#82aaff",
      "accent": "#89ddff",
      "success": "#c3e88d",
      "warning": "#ffcb6b",
      "error": "#f07178",
      "info": "#f78c6c"
    },
    "overrides": {
      "text-weak": "#676e95",
      "syntax-comment": "#676e95",
      "syntax-keyword": "#c792ea",
      "syntax-string": "#c3e88d",
      "syntax-primitive": "#82aaff",
      "syntax-variable": "#a6accd",
      "syntax-property": "#89ddff",
      "syntax-type": "#ffcb6b",
      "syntax-constant": "#f78c6c",
      "syntax-operator": "#89ddff",
      "syntax-punctuation": "#a6accd",
      "syntax-object": "#a6accd",
      "markdown-heading": "#c792ea",
      "markdown-text": "#a6accd",
      "markdown-link": "#82aaff",
      "markdown-link-text": "#89ddff",
      "markdown-code": "#c3e88d",
      "markdown-block-quote": "#676e95",
      "markdown-emph": "#ffcb6b",
      "markdown-strong": "#f78c6c",
      "markdown-horizontal-rule": "#676e95",
      "markdown-list-item": "#82aaff",
      "markdown-list-enumeration": "#89ddff",
      "markdown-image": "#82aaff",
      "markdown-image-text": "#89ddff",
      "markdown-code-block": "#a6accd"
    }
  }
}
